import { useState } from "react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { useBoolean } from "@/react/hooks/utils/useBoolean";
import { useAnyHoverMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Typography } from "@circle-react-uikit/Typography";
import { useFiles } from "./hooks/useFiles";

export const ContextualMenu = ({ file }) => {
  const [shouldShowConfirmationModal, toggleConfirmationModal] =
    useBoolean(false);
  const { removeFile, isRemovingFile } = useFiles();
  const canHover = useAnyHoverMediaQuery();
  const [hasDropdownOpen, setHasDropdownOpen] = useState(false);

  const handleRemoveFile = fileId => {
    removeFile(fileId);
  };

  return (
    <>
      <ConfirmationModal
        isOpen={shouldShowConfirmationModal}
        title={t("courses.edit.lesson.tabs.files.delete_modal.title")}
        onClose={toggleConfirmationModal}
        onCancel={toggleConfirmationModal}
        onConfirm={() => handleRemoveFile(file.id)}
        confirmVariant="danger"
        disabled={isRemovingFile}
        confirmText={isRemovingFile ? t("deleting") : t("delete")}
      >
        {t("courses.edit.lesson.tabs.files.delete_modal.description")}
      </ConfirmationModal>
      <Dropdown
        direction="bottom-end"
        className={classNames("text-dark -mt-1 flex justify-end", {
          "invisible group-hover:visible": canHover && !hasDropdownOpen,
        })}
        buttonWrapperClassName="ml-1"
        onToggle={setHasDropdownOpen}
        button={
          <IconButton variant="secondary" name="16-menu-dots-horizontal" />
        }
      >
        <Dropdown.ItemWithLink
          onClick={event => {
            event.preventDefault();
            window.open(file.url);
          }}
        >
          {t("courses.edit.lesson.tabs.files.view")}
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          disabled={isRemovingFile}
          onClick={event => {
            event.preventDefault();
            toggleConfirmationModal();
          }}
        >
          <Typography.LabelSm color="text-v2-danger">
            {t("courses.edit.lesson.tabs.files.delete")}
          </Typography.LabelSm>
        </Dropdown.ItemWithLink>
      </Dropdown>
    </>
  );
};
